import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import ListaModulos from '../components/ListaModulos';
import { myApi } from '../../../../config/axiosConfig';
import MyTextInput from '../../../../components/inputs/MyTextInput';
import Swal from 'sweetalert2';

const CrearEditarPerfilModal = ({ open, onClose, refresh, profile, isEditing }) => {
    const [modulosSeleccionados, setModulosSeleccionados] = useState({
        catalogoModulos: [],
        modulosSeleccionados: []
    });

    const fetchModules = async () => {
        try {
            const response = await myApi.get('/perfiles/getModulos');
            let respuestaPerfil = [];
            if (isEditing) {
                const responseProfile = await myApi.get(`/perfiles/getModulosPerfil/${profile.id_perfil}`);

                respuestaPerfil = responseProfile.data.data;
            }
            setModulosSeleccionados({
                catalogoModulos: response.data.data,
                modulosSeleccionados: respuestaPerfil,
            });
        } catch (error) {
            console.error('Error fetching modules:', error);
        }
    };

    const handleSave = async (values) => {
        console.log(values);
        let modulosLocalStorage = JSON.parse(localStorage.getItem('seleccionados'));
        
        const payload = {
            nombre_perfil: values.nombrePerfil,
            modulos: modulosLocalStorage,
        };
        try {
            if (isEditing) {
                payload.id_perfil = profile.id_perfil;
                await myApi.put(`/perfiles/editar`, payload);
            } else {
                await myApi.post('/perfiles/crear', payload);
            }
            refresh();
            onClose();
            Swal.fire({
                icon: 'success',
                title: 'Perfil guardado',
            });
        } catch (error) {
            console.error('Error saving profile:', error);
        }
    };

    useEffect(() => {
        fetchModules();
    }, [profile, isEditing]);



    const validationSchema = Yup.object({
        nombrePerfil: Yup.string().required('El nombre del perfil es requerido')
    });

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>{isEditing ? 'Editar Perfil' : 'Crear Perfil'}</DialogTitle>
            <DialogContent>
                <Formik
                    initialValues={{
                        nombrePerfil: isEditing ? profile.nombre_perfil : '',
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSave}
                >
                    {({ values, handleChange }) => (
                        <Form>
                            <MyTextInput name="nombrePerfil" label="Nombre del Perfil" />
                            <ListaModulos
                                catalogoModulos={modulosSeleccionados.catalogoModulos}
                                isEditing={isEditing}
                                modulosSeleccionados={modulosSeleccionados.modulosSeleccionados}
                            />
                            <DialogActions>
                                <Button onClick={onClose}>Cancelar</Button>
                                <Button type="submit" variant="contained" color="primary">
                                    Guardar
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    );
};

export default CrearEditarPerfilModal;